export default {
  state: {},
  mutations: {
    error(state, payload) {
      (this as any).$app.$toastr.e(payload);
    },
    success(state, payload) {
      (this as any).$app.$toastr.s(payload);
    },
  },
  namespaced: true,
};
